//header.js
import React, {Component} from 'react';
import axios from 'axios';
import { Avatar, Box, Tooltip, Menu, MenuItem, Typography, IconButton, AppBar, Toolbar, Link } from '@mui/material';
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import logo from '../../assets/images/DashboardIcon/Icon/gazelle.jpg';
import './css/Header.css';

const pages = ['Products', 'Pricing', 'Blog'];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function Header() {

const { isLoading, isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

const handleLogoff = (event) =>	{		
	if (isAuthenticated)
	{
		event?.preventDefault();
		logout({
    		logoutParams: {
      			returnTo: window.location.origin // Redirect to home after logout
    		}
  		});	
	}
	
	}


	const { user } = useAuth0();
  	const username = user?.username || 
                   user?.nickname || 
                   user?.email?.split('@')[0];
    return (
				
			<AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, height: 65, bgcolor: "grey" } }>
				<Toolbar>
					<div className="left-section">
							<a href="/" >
								<img src={logo} width={50}/>
								<span><span ><i class="flaticon-grid-menu"></i></span></span>
							</a>
					</div>
					<div className="middle-section">
						<span>Hello, {username}</span>
					</div>
					<div className="right-section">
          <Box sx={{ flexGrow: 0, position: 'absolute',
    			right: 20, // Sticks to right edge
    			top: 13 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={username} src="/static/images/avatar/2.jpg" />
              </IconButton>
              <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              >
              	<MenuItem>
              		<Typography sx={{ textAlign: 'center' }}>Profile</Typography>
              	</MenuItem>
              	<MenuItem onClick={handleLogoff}>
              		<Typography sx={{ textAlign: 'center' }}>Logout</Typography>
              	</MenuItem>
              </Menu>
            </Tooltip>
		</Box>
					</div>


				</Toolbar>
			</AppBar>
			
	)		
}	
export default Header;